/**
 * @file オプション解約情報を管理するステート
 *
 * ユーザーが解約しようとしているオプションの情報（オプション名・利用状況・
 * オーダー種別）を保持する。オプション解約画面（option-quit）で
 * 選択されたオプションの詳細を確認画面・完了画面へ引き継ぐ。
 * セッションストレージに永続化される。
 */
import { Constants } from '@/utils/constants';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** オプション解約情報の型 */
export type QuitOptionInfoStateType = {
  /** オプション名称 */
  option_name: string;
  /** 利用ステータス */
  use_status: string;
  /** オプション詳細 */
  option_info: {
    /** オプションコード */
    option_code: string;
    /** オプションクラス種別 */
    option_class_type: string;
    /** オーダー種別（Constants.OptionOrderTypeで定義） */
    order_type: number;
  };
};

export const quitOptionInfoState = atom<QuitOptionInfoStateType>({
  key: 'quitOptionInfoState',
  default: {
    option_name: '',
    use_status: '',
    option_info: {
      option_code: '',
      option_class_type: '',
      order_type: Constants.OptionOrderType.SIMPLE_QUIT,
    },
  },
  effects_UNSTABLE: [persistAtom],
});

export default quitOptionInfoState;
